import axios from 'axios';
import { BASE_URL } from '../../Constants/constants';

// Create a function to get an authenticated Axios instance
export const getAuthenticatedAxios = () => {
    // 1. Token Retrieval
    // Fetch the access token stored in local browser storage
    // This assumes your login process stores the token with the key 'accessToken'
    const token = localStorage.getItem('accessToken');

    // 2. Configuration Object
    // Create headers configuration with Bearer token authentication
    const config = {
        headers: {
            // Standard OAuth 2.0 Bearer token format
            Authorization: `Bearer ${token}`
        }
    };

    // 3. Axios Instance Creation
    // Create a custom axios instance with:
    // - Base URL from constants
    // - Timeout to prevent indefinite waiting
    // - Pre-configured authentication headers
    const axiosInstance = axios.create({
        baseURL: BASE_URL,
        timeout: 10000, // 10 seconds timeout
        ...config // Spread the authorization config
    });

    // 4. Response Interceptor
    // Add global response handling for:
    // - Error logging
    // - Authentication failure management
    axiosInstance.interceptors.response.use(
        // Success handler (pass through successful responses)
        response => response,

        // Error handler
        error => {
            // Comprehensive error logging
            if (error.response) {
                // Server responded with an error status
                console.error('API Error Details:', {
                    status: error.response.status,
                    data: error.response.data,
                    headers: error.response.headers
                });

                // Handle specific error scenarios
                switch (error.response.status) {
                    case 401:  // Unauthorized
                        console.log('Authentication failed. Please log in again.');
                        // Optional: Redirect to login page or trigger re-authentication
                        // window.location.href = '/login';
                        break;

                    case 403:  // Forbidden
                        console.log('You do not have permission to access this resource.');
                        break;

                    case 404:  // Not Found
                        console.log('Requested resource not found.');
                        break;

                    case 500:  // Internal Server Error
                        console.log('Server encountered an internal error.');
                        break;
                }
            } else if (error.request) {
                // Request made but no response received (network error)
                console.error('No response received from server:', error.request);
            } else {
                // Error in setting up the request
                console.error('Error setting up request:', error.message);
            }

            // Ensure the error is propagated for component-level handling
            return Promise.reject(error);
        }
    );

    // 5. Return the configured Axios instance
    return axiosInstance;
};

// Optional: Axios Request Logging Utility
// Helps in debugging by logging details of each request
export const logAxiosRequest = (config) => {
    console.log('Request:', {
        method: config.method,
        url: config.url,
        baseURL: config.baseURL,
        headers: config.headers
    });
    return config;
};